import { useGetTotalPointsEarnedQuery } from '@ocx/graphql';

export type UseTotalPointsEarnedProps = {
  skip?: boolean;
};

export const useTotalPointsEarned = (props: UseTotalPointsEarnedProps = {}) => {
  const { data, refetch, networkStatus } = useGetTotalPointsEarnedQuery({
    skip: props.skip,
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });
  const totalPointsEarned = data?.customer?.membership?.lifetimeMetrics?.pointsEarned ?? 0;

  return { totalPointsEarned, refetch, networkStatus };
};
